<template>
    <div class="p-6">
        <p class="mb-2 text-lg font-semibold text-neutral-900"> {{ title }} </p>
        <p class="mb-4 text-sm text-neutral-600"> {{ date }} </p>
        <div class="mb-4">
            <p class="text-sm text-neutral-900" v-html="description" />
        </div>
        <div class="cursor-pointer" v-if="cleanseUrl" @click="redirect()">
            <button-component
                size="large"
            >
                <span> {{ buttonText }} </span>
                <!-- <img src="/assets/icon/ic-arrow-right.svg" alt="right_icon" class="w-5 h-5 ml-2 icon"/> -->
                <arrow-right-icon class="w-5 h-5 ml-2 icon" />
            </button-component>
        </div>
        <a v-else :href="routeLink">
            <button-component
                size="large"
            >
                <span> {{ buttonText }} </span>
                <!-- <img src="/assets/icon/ic-arrow-right.svg" alt="right_icon" class="w-5 h-5 ml-2 icon"/> -->
                <arrow-right-icon class="w-5 h-5 ml-2 icon" />
            </button-component>
        </a>
    </div>
</template>
<script setup lang="ts">
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import ArrowRightIcon from "@/components/icons/arrowRightIcon.vue";
import { computed } from 'vue';
import { useRouter } from 'vue-router';
const props = defineProps({
    title: {
        type: String,
        default: null,
    },
    date: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    routeLink: {
        type: String,
        default: null,
    },
    buttonText: {
        type: String,
        default: null,
    },
});

const router = useRouter();

const cleanseUrl = computed(() => {
    const url = props.routeLink.split('https://www.wcpmis.org');
    return url[1] == undefined ? false : true;
});

const redirect = () => {
    const url = props.routeLink.split('https://www.wcpmis.org');
    router.push(url[1]);
}
</script>